import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0 bg-white calendar-card mb-25" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "calendar" }, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_EventsModal = _resolveComponent("EventsModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading === true)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _hoisted_3,
        _createCommentVNode(" ADD "),
        (_ctx.patient_summary?.id !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createCommentVNode(" SAVE "),
              _createElementVNode("button", {
                disabled: _ctx.selectedTime === undefined || !_ctx.dateAvailable,
                class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16 mt-25",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
              }, _toDisplayString(_ctx.$t('cta.add_event')), 9 /* TEXT, PROPS */, _hoisted_6)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createVNode(_component_EventsModal, {
      id: "event_modal",
      time_info: _ctx._time,
      patient_summary: _ctx.patient_summary,
      onSave: _cache[1] || (_cache[1] = event => _ctx.saveEvent(event))
    }, null, 8 /* PROPS */, ["time_info", "patient_summary"]),
    _createVNode(_component_EventsModal, {
      id: "update_event_modal",
      event_update: _ctx._selectedEvent,
      patient_summary: _ctx.patient_summary,
      onUpdate: _cache[2] || (_cache[2] = event => _ctx.updateEvent(event)),
      onDelete: _ctx.deleteConfirm
    }, null, 8 /* PROPS */, ["event_update", "patient_summary", "onDelete"]),
    _createVNode(_component_ConfirmModal, {
      id: "delete_event",
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteEvent())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}